import { render, staticRenderFns } from "./Soja2022SitiosRamsarParaguai.vue?vue&type=template&id=55929567&lang=pug"
import script from "./Soja2022SitiosRamsarParaguai.vue?vue&type=script&lang=js"
export * from "./Soja2022SitiosRamsarParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports